import PropTypes from 'prop-types';
import { getPriceForPeriod } from '../../utils/price-for-period';
import PeriodPrice from './PeriodPrice';

export default function AddonItem({
    addon,
    period,
    isSelected,
    hasSubdirectory,
    showDetails,
    onAdd,
    onRemove,
    onToggleDetails,
}) {
    let button = (
        <button className="gh-btn gh-btn-sm" onClick={() => onAdd(addon)}>
            Add
        </button>
    );

    if (isSelected) {
        // Disable the remove button when the site has an activated subdirectory
        if (hasSubdirectory && addon?.name?.match(/subdirectory/i)) {
            button = <div className="gh-btn gh-btn-green gh-btn-sm disabled ">Active</div>;
        } else {
            button = (
                <button className="gh-btn gh-btn-grey gh-btn-sm" onClick={() => onRemove(addon)}>
                    Remove
                </button>
            );
        }
    }

    const { cost, billing_period: billingPeriod } = getPriceForPeriod(addon, period);

    return (
        <div className="box-addon-item">
            <div className="plandetails-split">
                <h3>{addon.name}</h3>
                <div>
                    <PeriodPrice cost={cost} billingPeriod={billingPeriod} period={period} />
                </div>
            </div>
            <p
                className={`addon-desc ${showDetails ? 'open' : 'hidden'}`}
                dangerouslySetInnerHTML={{ __html: addon?.description }}
            ></p>
            <footer>
                <button className="addon-desc-toggle" onClick={() => onToggleDetails(addon.name)}>
                    {showDetails ? 'Hide details ↑' : 'Show details →'}
                </button>
                {button}
            </footer>
        </div>
    );
}

AddonItem.propTypes = {
    addon: PropTypes.shape({
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        prices: PropTypes.arrayOf(
            PropTypes.shape({
                cost: PropTypes.number,
                billing_period: PropTypes.string,
            }),
        ).isRequired,
    }).isRequired,
    period: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    hasSubdirectory: PropTypes.bool,
    showDetails: PropTypes.bool,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    onToggleDetails: PropTypes.func.isRequired,
};
